// FILE: src/config/menuConfig.js
export const MENU_ITEMS = [
    // Public/member
    { id: "home", label: "Home", path: "/", roles: ["admin", "member"] },
    { id: "events", label: "Events", path: "/events", roles: ["admin", "member"] },
    { id: "devotionals", label: "Devotionals", path: "/devotionals", roles: ["admin", "member"] },
    { id: "content", label: "Content", path: "/content", roles: ["admin", "member"] },
    { id: "chat", label: "Chat", path: "/chat", roles: ["admin", "member"] },
    { id: "profile", label: "My Profile", path: "/profile", roles: ["member"] },
  
    // Admin
    { id: "admin.dashboard", label: "Dashboard", path: "/dashboard", roles: ["admin"] },
    { id: "admin.members", label: "Members", path: "/members", roles: ["admin"] },
    { id: "admin.addMember", label: "Add Member", path: "/add-member", roles: ["admin"] },
    { id: "admin.attendance", label: "Attendance", path: "/attendance", roles: ["admin"] },
    { id: "admin.attendanceReport", label: "Attendance Analytics", path: "/admin/attendance-report", roles: ["admin"] },
    { id: "admin.events", label: "Manage Events", path: "/admin/events", roles: ["admin"] },
    { id: "admin.devotionals", label: "Manage Devotionals", path: "/admin/devotionals", roles: ["admin"] },
    { id: "admin.uploadContent", label: "Upload Content", path: "/admin/content/upload", roles: ["admin"] },
  ];
  